/**
 * 项目配置数据文件
 * 存储所有项目的配置信息，与配置管理逻辑分离
 */

/**
 * 项目配置数组 - 存储所有项目的配置信息
 */
export const projectConfigs = [
  // 科右中旗牛业项目
  {
    projectId: 'kyzq',
    projectName: '科右中旗牛业全产业链',
    apiBaseUrl: '/sznc',
    wechat: {
      appid: 'wx7650561dc89e59af',
      appSecret: '', // 不在前端暴露
      enabled: true,
      shareEnabled: true
    },
    features: {
      shareEnabled: true
    },
    status: 'active'
  },
  // 演示项目
  {
    projectId: 'demo',
    projectName: '演示项目',
    apiBaseUrl: '/api',
    wechat: {
      appid: '',
      appSecret: '',
      enabled: false,
      shareEnabled: false
    },
    features: {
      shareEnabled: false
    },
    status: 'inactive'
  },
  // 测试项目
  {
    projectId: 'test',
    projectName: '测试项目',
    apiBaseUrl: '/test',
    wechat: {
      appid: 'wx1234567890abcdef',
      appSecret: '',
      enabled: true,
      shareEnabled: true
    },
    features: {
      shareEnabled: true
    },
    status: 'active'
  }
]

/**
 * 项目配置错误码定义
 */
export const ProjectConfigError = {
  NO_PROJECT_ID: '未获取到有效的项目标识',
  CONFIG_NOT_FOUND: '未查询到对应的项目配置信息',
  PROJECT_INACTIVE: '项目未激活',
  SHARE_DISABLED: '分享功能已禁用',
  APPID_MISSING: '微信appid未配置'
}